import axios from 'axios';
import React, { useState } from 'react'
import { Box } from '@mui/system'
import moment from 'moment'
import './Card.css'
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';

import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { config } from '../App';



const CardView = ({filterAge,filterGenre,filterSort,searchCard}) => {
  let Navigate = useNavigate();
  const [videos, setVideos] = useState([]);
  const [filtervideos, setFilterVideos] = useState([]);

  console.log("Age:",filterAge," Genre:",filterGenre)
  useEffect(() => {
    console.log("1st call",filterAge,filterGenre);
    performAPICall();
  }, [])
  
  useEffect(() => {
    console.log("update call",filterAge,filterGenre);
    filterItem(filterAge, filterGenre, filterSort,searchCard)
  },[filterAge, filterGenre,filterSort,searchCard])


  const filterItem = (filterAge, filterGenre, filterSort, searchCard) => {
    console.log("infilter",searchCard)
    if (searchCard !== "") {
      
      let newVideos = videos.filter((video) => {
        console.log(video.title.includes(searchCard))
        return video.title.includes(searchCard); 
      })
      setFilterVideos(newVideos);
    } else {

      
      if (filterSort === true) {
        console.log("i am called for sort");
        
        let sortedVideo=filtervideos.sort(
          (objA, objB) => Number(moment(objA.releaseDate).format("YYYYMMDD")) - Number(moment(objB.releaseDate).format("YYYYMMDD")),
      );
      setFilterVideos(sortedVideo);
    }
    if (filterSort === false) {
      console.log("i am called for sort");
      
      let sortedVideo=filtervideos.sort(
        (objA, objB) => Number(moment(objB.releaseDate).format("YYYYMMDD")) - Number(moment(objA.releaseDate).format("YYYYMMDD")),
        );
        setFilterVideos(sortedVideo);
      }
      if (filterAge === "Any" && filterGenre==="All") {
        console.log("age condition called")
        setFilterVideos(videos);
      }
      else if (filterGenre === "All") {
        let newVideos = videos.filter((video) => {
          return video.contentRating===filterAge
        })
        setFilterVideos(newVideos);
      }
      else if (filterAge === "Any") {
        let newVideos = videos.filter((video) => {
          return video.genre===filterGenre 
        })
        setFilterVideos(newVideos);
      }
      else {  
        let newVideos = videos.filter((video) => {
          return video.genre===filterGenre && video.contentRating===filterAge
        })
        setFilterVideos(newVideos);
      }
    }

  }

  const performAPICall = async () => {
    //console.log("i am called");
    console.log("i am performAPICall");
    const URL = config.endpoint + "/videos";
    try {
      const response = await axios({
        url: URL,
        method: "get",
      });
      //console.log(response.data.videos);
    
      setVideos(response.data.videos);
      setFilterVideos(response.data.videos);
      // return response.data;
      return response;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          console.log(error.response.data.message);
        }
      } else {
        console.log("something went wrong")
      }
      return error;
    }
  };
  //console.log(typeof (videos));
  return (
    <div>
      <Box sx={{ px: 6, py: 5, flexGrow: 1 }} bgcolor="primary.dark">

        <Grid container rowSpacing={6} spacing={{ xs: 3 }} sx={{ px: 6 }} columns={{ xs: 3, sm: 6, md: 12 }}>

          { filtervideos.length===0 ? <div className='emptyarea' ></div> :

            filtervideos.map((video) => (
              <Grid item xs={3} md={3} sm={3} key={video._id}>
                <Card sx={{ maxWidth: 345 }} className="card" > 
                  <CardMedia
                   sx={{borderBottom:1}}
                    component="img"
                    height="200"
                    image={video.previewImage}
                    alt="green iguana"
                  />
                  <CardContent style={{ bgcolor: "white" }} >
                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}>
                      <Box >
                        <Typography gutterBottom component="div" color="text.primary" className="content">
                          {video.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {
                            moment(video.releaseDate).fromNow()
                          }
                        </Typography>
                      </Box>
                      <Box sx={{ py: 0.1}}>
                              <IconButton color="secondary" size="large" onClick={()=>{Navigate(`/videos/${video._id}`)}}>
                          <PlayCircleOutlineIcon sx={{ fontSize: "2.5rem", color:"red" }} />
      </IconButton>
                      </Box>

                    </Box>


                  </CardContent>

                </Card>
              </Grid>

            ))}
        </Grid>
      </Box>
    </div>
  )
}

export default CardView